import {Store} from 'models/store.model';
import {callApi} from './api';

export const fetchStoreRequest = async (storeId: number): Promise<Store> => {
  return callApi<Store>(`/stores/${storeId}`, {}).then(({data}) => data);
};
